import { performFullNewCustomerReset } from '@/lib/performFullNewCustomerReset';
import { useEffect, useRef } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import StaffRefCapture from '@/components/survey/StaffRefCapture';
import StaffSurveyGate from '@/components/survey/StaffSurveyGate';
import AgeSmoker from '@/pages/AgeSmoker';
import CustCompleted from '@/pages/CustCompleted';
import Home from '@/pages/Home';
import LdProductNow from '@/pages/LdProductNow';
import Otp from '@/pages/Otp';
import Pdpa from '@/pages/Pdpa';
import Phone from '@/pages/Phone';
import PrevBrand from '@/pages/PrevBrand';
import PrevBrandAnswer from '@/pages/PrevBrandAnswer';
import PrevBrandAnswerOther from '@/pages/PrevBrandAnswerOther';
import PrevBrandOther from '@/pages/PrevBrandOther';
import SetBLdBrandOpinion from '@/pages/SetBLdBrandOpinion';
import SetAProfile from '@/pages/SetAProfile';
import SurveyContinue from '@/pages/SurveyContinue';
import ThankYou from '@/pages/ThankYou';
import Tng from '@/pages/Tng';
import StaffRequired from '@/pages/StaffRequired';
import WhyLdNow from '@/pages/WhyLdNow';

function ResetClientWhenLeavingTng() {
  const { pathname } = useLocation();
  const prevPath = useRef(pathname);
  useEffect(() => {
    const wasTng = prevPath.current === '/tng';
    const nowTng = pathname === '/tng';
    if (wasTng && !nowTng) {
      performFullNewCustomerReset();
    }
    prevPath.current = pathname;
  }, [pathname]);
  return null;
}

function Router() {
  const routes = useRoutes([
    { path: '/staff-required', element: <StaffRequired /> },
    { path: '/', element: <Home /> },
    { path: '/age_smoker', element: <AgeSmoker /> },
    { path: '/pdpa', element: <Pdpa /> },
    { path: '/phone', element: <Phone /> },
    { path: '/otp', element: <Otp /> },
    { path: '/ldproductnow', element: <LdProductNow /> },
    { path: '/likelyld', element: <SetBLdBrandOpinion /> },
    { path: '/survey/set-b/brand-opinion', element: <Navigate to="/likelyld" replace /> },
    { path: '/survey/set-a/profile', element: <SetAProfile /> },
    { path: '/survey/prevbrand', element: <PrevBrand /> },
    { path: '/survey/prevbrandanswer', element: <PrevBrandAnswer /> },
    { path: '/survey/other-product', element: <Navigate to="/survey/prevbrand-other" replace /> },
    { path: '/survey/prevbrand-other', element: <PrevBrandOther /> },
    { path: '/survey/prevbrandanswer-other', element: <PrevBrandAnswerOther /> },
    { path: '/whyldnow', element: <WhyLdNow /> },
    { path: '/whynotld', element: <Navigate to="/whyldnow" replace /> },
    { path: '/tng', element: <Tng /> },
    { path: '/survey', element: <SurveyContinue /> },
    { path: '/custcompleted', element: <CustCompleted /> },
    { path: '/thankyou', element: <ThankYou /> },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);

  return (
    <>
      <StaffRefCapture />
      <ResetClientWhenLeavingTng />
      <StaffSurveyGate>{routes}</StaffSurveyGate>
    </>
  );
}

export default Router;
